function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
//import appApis from '@/services/services'
import assignments_service from '@/apps/data-platform/services/tables_views/assignments_service';
import tables_service from '@/apps/data-platform/services/tables_views/tables_service';
import { textsDefaul, envConfig, TYPE_CHANGE_METADA, TAG_QUERIES, PATTERNS_VALIDATION } from '@/js/constants';
import PaginationCatalog from '@/components/PaginationCatalog.vue';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import FormAssignTemporalOwner from '@/components/FormAssignTemporalOwner.vue';
export default {
  name: 'MassiveUpdatePage',
  components: {
    PaginationCatalog: PaginationCatalog,
    FormAssignTemporalOwner: FormAssignTemporalOwner
  },
  data: function data() {
    return {
      selected: [],
      dialogFlag: false,
      MODAL_NAME_ALL_OWNER: 'ContTablesMeOwner',
      queryResponse: null,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      PAGE_SIZE: envConfig.pagintaionSize,
      PAGE_TAGS_SIZE: envConfig.pagintaionTagsSize,
      Q_DEFAULT: TAG_QUERIES.ALL_WITH_OWNER,
      messageEmptyList: textsDefaul.LOADING,
      filter: '',
      tablas: [],
      tableFlag: false,
      isNewQuery: true,
      paramsSearch: {},
      tablesToDownload: Array,
      isButtonDownloadHidden: false,
      checkAll: false,
      SEARCH_EMAIL: PATTERNS_VALIDATION.EMAIL,
      relativeResourceNames: Array,
      fromEmail: '',
      inputSearch: '',
      search: {},
      filter_enabled: false,
      // true,
      pagination: {
        limit: 10,
        offset: 0,
        current: 1
      },
      key_pagination: 1,
      key_table: 1
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['isDomainItc', 'projects', 'catalogs'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('my_pendings.massive_subtitle'),
        disabled: true
      }];
    },
    headers: function headers() {
      return [
      //{ value: 'selected', variant: 'return-sort' },
      {
        text: this.traductor('my_tasks.tablas_tasks.table'),
        value: 'tableReference.tableId',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_tasks.tablas_tasks.columns'),
        value: 'schema.fields.length',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_tasks.tablas_tasks.rows'),
        value: 'numRows',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_tasks.tablas_tasks.creation_date'),
        value: 'creationTime',
        sortable: true,
        align: 'center'
      }];
    },
    texts: function texts() {
      return {
        assign_operator: this.traductor('frases.asignar_operator_modal') + this.fromEmail
      };
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    }
  }),
  created: function created() {
    //this.reloadList()
  },
  methods: {
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    enterSelect: function enterSelect() {
      this.tablesToDownload = this.selected;
      console.log("dbug:", this.tablesToDownload);
      this.isButtonDownloadHidden = this.tablesToDownload.length > 0;
    },
    sendToFilter: function sendToFilter(q) {
      this.filter = q;
    },
    sendToSearch: function sendToSearch(q) {
      if (q) {
        this.fromEmail = q;
        this.isNewQuery = true;
        this.Q_DEFAULT = "".concat(TAG_QUERIES.ALL_WITH_OWNER, ":").concat(q);
        // add input to filter
        this.reloadList(); // reload list
        return true;
      }
    },
    processParams: function processParams(params) {
      var _ref = params || {},
        _ref$email = _ref.email,
        email = _ref$email === void 0 ? window.userInfo.email : _ref$email,
        _ref$domain = _ref.domain,
        domain = _ref$domain === void 0 ? window.userInfo.domain : _ref$domain,
        _ref$query = _ref.query,
        query = _ref$query === void 0 ? this.Q_DEFAULT || '' : _ref$query,
        _ref$pageSize = _ref.pageSize,
        pageSize = _ref$pageSize === void 0 ? this.PAGE_SIZE : _ref$pageSize,
        _ref$searchWithTags = _ref.searchWithTags,
        searchWithTags = _ref$searchWithTags === void 0 ? true : _ref$searchWithTags,
        _ref$allDomains = _ref.allDomains,
        allDomains = _ref$allDomains === void 0 ? false : _ref$allDomains,
        _ref$approval_flow = _ref.approval_flow,
        approval_flow = _ref$approval_flow === void 0 ? false : _ref$approval_flow,
        _ref$nextToken = _ref.nextToken,
        nextToken = _ref$nextToken === void 0 ? undefined : _ref$nextToken,
        _ref$conditions = _ref.conditions,
        conditions = _ref$conditions === void 0 ? undefined : _ref$conditions,
        _ref$getAccessTables = _ref.getAccessTables,
        getAccessTables = _ref$getAccessTables === void 0 ? false : _ref$getAccessTables;
      this.paramsSearch = nextToken === undefined ? {
        email: email,
        domain: domain,
        query: query,
        pageSize: pageSize,
        searchWithTags: searchWithTags,
        allDomains: allDomains,
        approval_flow: approval_flow,
        nextToken: nextToken,
        conditions: conditions,
        getAccessTables: getAccessTables
      } : _objectSpread(_objectSpread({}, this.paramsSearch), {}, {
        nextToken: nextToken
      });
      return this.paramsSearch;
    },
    reloadList: function reloadList(params) {
      var _this = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var defaultParams = {
        operator: this.fromEmail,
        params: this.search,
        catalogs: this.catalogs,
        projects: this.projects,
        nextToken: this.nextToken,
        limit: this.pagination.limit
      };

      //this.processParams(params)
      var self = this;
      //appApis.queryServiceNew(defaultParams).then(response => {
      assignments_service.getByOperator(defaultParams).then(function (response) {
        if (response && response.code === 200) {
          if (response && response.data && response.data.tables && response.data.tables) {
            if (response.data.next_page_token && Object.keys(response.data.next_page_token).length > 0) {
              console.log("has next page");
              if (!_this.pagination.tokens) _this.pagination.tokens = {};
              _this.pagination.tokens[_this.pagination.current + 1] = response.data.next_page_token;
              _this.pagination.next_page_token = response.data.next_page_token;
            } else {
              console.log("no next page");
              _this.pagination.next_page_token = {};
            }
            _this.key_pagination += 1;
            _this.queryResponse = response.data || {};
            _this.tablas = response.data.tables;
            _this.tableFlag = true;
            //tasks.combineTagsInRows(this.queryResponse)
            self.getTagsTables(self.queryResponse.tables);
            self.getDetailsTables(self.queryResponse.tables);
          } else {
            _this.queryResponse = response.data || {};
            _this.messageEmptyList = textsDefaul.NOT_TABLES;
          }
        } else {
          //this.reloadList(defaultParams, callback)
        }
        _this.isNewQuery = false;
        callback && callback(response);
      }).catch(function (e) {
        utils.printError(e);
        self.messageEmptyList = 'The request was interrupted, try again';
        // this.reloadList(defaultParams, callback)
      });
    },
    getTagsTables: function getTagsTables(tables) {
      var _this2 = this;
      var params = {
        tables: tables
      };
      tables_service.getTags(params).then(function (response) {
        _this2.loading_tags = false;
        if (response.data) {
          _this2.queryResponse.tables.forEach(function (item) {
            response.data.forEach(function (x) {
              if (item.relativeResourceName == x.relativeResourceName) {
                item['tags'] = x['tags'];
                x['tags'].forEach(function (tag) {
                  if (tag.templateDisplayName == 'tpl_tables') {
                    item['defaultFields'] = tag;
                  }
                });
              }
            });
          });
          console.log(_this2.queryResponse.tables);
          //tasks.combineTagsInRows(this.queryResponse)
          if (_this2.loading_tags == false && _this2.loading_schema == false) {
            //this.verifyColumnsWithoutTags()
          }
          _this2.key_table += 1;
        }
      }, function (err) {
        _this2.loading_tags = false;
      });
    },
    getDetailsTables: function getDetailsTables(_tables) {
      var _this3 = this;
      var tables = [];
      this.queryResponse.tables.forEach(function (item) {
        tables.push({
          projectId: item.tableReference.projectId,
          datasetId: item.tableReference.datasetId,
          tableId: item.tableReference.tableId,
          domain_table: item.domain_table,
          source: item.source ? item.source : "bigquery"
        });
      });
      var params = {
        'tables': tables
      };
      assignments_service.getTablesDetails(params).then(function (response2) {
        _this3.loading_schema = false;
        console.log(response2);
        if (response2.data) {
          var _loop = function _loop(key) {
            var items = _this3.queryResponse.tables.filter(function (x) {
              return x.id == response2.data[key].id;
            });
            items.forEach(function (y) {
              y['schema'] = response2.data[key]['schema'];
              y['numRows'] = response2.data[key]['numRows'];
              y['creationTime'] = response2.data[key]['creationTime'];
            });
          };
          for (var key in response2.data) {
            _loop(key);
          }
          if (_this3.loading_tags == false && _this3.loading_schema == false) {
            //this.verifyColumnsWithoutTags()
          }
          _this3.key_table += 1;
        }
      }, function (err) {
        _this3.loading_schema = false;
      });
    },
    onRowSelected: function onRowSelected(items) {
      this.tablesToDownload = items;
      this.isButtonDownloadHidden = this.tablesToDownload.length > 0;
    },
    openModal: function openModal() {
      this.relativeResourceNames = this.tablesToDownload.map(function (rec) {
        return rec.relativeResourceName;
      });
      this.$refs[this.MODAL_NAME_ALL_OWNER].onOpen();
      //this.$bvModal.show(this.MODAL_NAME_ALL_OWNER)
    },
    selectAllRows: function selectAllRows() {
      this.checkAll = !this.checkAll;
      if (this.checkAll) {
        this.$refs.selectableTable.selectAllRows();
      } else {
        this.$refs.selectableTable.clearSelected();
      }
    },
    assignTableByDataOperator: function assignTableByDataOperator() {
      //this.$bvModal.hide(this.MODAL_NAME_ALL_OWNER)
      this.$refs[this.MODAL_NAME_ALL_OWNER].onClose();
      this.reloadList();
      return true;
    },
    changePagina: function changePagina(page) {
      console.log(page, this.pagination.tokens);
      if (page == 1) {
        this.nextToken = {};
        this.pagination.tokens = null;
        this.pagination.next_page_token = {};
      } else {
        this.nextToken = this.pagination.tokens[page];
      }
      this.reloadList();
    },
    onLimpiar: function onLimpiar() {
      this.inputSearch = "";
    }
  }
};